import AlertBanner from '@/components/common/AlertBanner';
import GlassCard from '@/components/GlassCard';
import PageTitle from '@/components/PageTitle';
import ThemeWrapper from '@/components/ThemeWrapper';
import { Heading } from '@/components/Typography';
import AppLayout from '@/layouts/AppLayout';
import CalendarEmbedCard from '@/pages/System/Partials/CalendarEmbedCard';
import { usePage } from '@inertiajs/react';
import React from 'react';

interface PageProps {
    calendarSrc: string | null;
    calendarTokenExpiresAt: string | null;
    [key: string]: unknown;
}

const Clases11Content: React.FC = () => {
    const { calendarSrc, calendarTokenExpiresAt } =
        usePage<PageProps>().props;

    return (
        <AppLayout>
            <PageTitle title="Clases 1-1" />
            <div className="mx-auto max-w-7xl space-y-6">
                <Heading as="h2">Clases 1-1</Heading>

                <CalendarEmbedCard
                    calendarSrc={calendarSrc}
                    calendarTokenExpiresAt={calendarTokenExpiresAt}
                />

                <GlassCard className="space-y-5 p-6">
                    <p className="text-gray-700 dark:text-neutral-300">
                        Las clases 1-on-1 se realizan aproximadamente{' '}
                        <strong>cada 15 días</strong>, así que es importante
                        que, al terminar cada clase, reserves aquí tu siguiente
                        sesión para no olvidarte.
                    </p>

                    <AlertBanner variant="amber">
                        Ten en cuenta que el sistema solo permite tener{' '}
                        <strong>una clase 1-on-1 reservada a la vez</strong>.
                        Esto significa que, si ya tienes una sesión pendiente, no
                        podrás reservar otra hasta que esa clase haya terminado.
                    </AlertBanner>

                    <p className="text-gray-700 dark:text-neutral-300">
                        Por eso, nuestra recomendación es que, justo al
                        finalizar cada 1-on-1, vuelvas a esta página y reserves
                        la siguiente clase.
                    </p>

                    <p className="text-gray-700 dark:text-neutral-300">
                        Además, el sistema no permite reservar una sesión con
                        menos de <strong>10 días de antelación</strong>, por lo
                        que te recomendamos planificar tus reservas con tiempo.
                    </p>

                    <p className="text-gray-700 dark:text-neutral-300">
                        Si necesitas cambiar una clase futura, simplemente
                        reserva una nueva desde este mismo calendario y la
                        anterior se cancelará automáticamente.
                    </p>
                </GlassCard>
            </div>
        </AppLayout>
    );
};

const Clases11: React.FC = () => (
    <ThemeWrapper>
        <Clases11Content />
    </ThemeWrapper>
);

export default Clases11;
